import React from "react";

// Styles
import styles from "../styles/PreparationFlow.module.css";


export default function Execute() {
  
	var selectedCourse = localStorage.getItem('etlSelectCourse'); 
  var mySelectedCourses = JSON.parse(localStorage.getItem("etlMyCourses"));

  let steps = [];

  if(mySelectedCourses && selectedCourse && mySelectedCourses[selectedCourse] && mySelectedCourses[selectedCourse].studyMaterial===1){
    steps.push({
      icon: "/static/images/s1.svg",
      title: "Avoid Information Overload",
      subtitle: "One time study is sufficient",
      points: ["Study any topic your way", "At school, coaching center, or web"],
      url: "studymaterials",
    });
  }

  if(mySelectedCourses && selectedCourse && mySelectedCourses[selectedCourse] && mySelectedCourses[selectedCourse].selfTest===1){
    steps.push({
      icon: "/static/images/s2.svg",
      title: "Identify Knowledge Gaps",
      subtitle:
        "Use Diagnostic Tool. You yourself will not be able to diagnose your weakness in the topic",
      points: [
        "Learning Session in ETL are AI-Driven & Randomly Created Multiple Formative Assessments on the same topic, each time with a unique set of questions to do an overall evaluation of your knowledge in the topic studied and pinpoint the exact weak areas where you are struggling.",
        "This learning exercise is preferably to be done on the day of the topic studied.",
      ],
      url: "selfassessor?gotab=beginner",
    });

    steps.push({
      icon: "/static/images/s3.svg",
      title: "Goodbye to Knowledge Gaps",
      subtitle:
        "You'll need a 24X7 Personal Assistant to help you learn on the go and fill the knowledge gap.",
      points: [
        "TONY Your Personal 24X7 AI Assistant will clear the doubts/concepts there & then.",
        "Repeat this exercise on the same topic till you move ahead of the exam Standard/Benchmark.",
        "Monitor this on the progress bar which will turn green when you cross the benchmark.",
      ],
      url: "selfassessor?gotab=beginner",
    });

    steps.push({
      icon: "/static/images/s4.svg",
      title: "Improve Speed & Accuracy",
      subtitle:
        "To complete a test in an exam in a fixed time with high accuracy.",
      points: [
        "Competitive Sessions in ETL help you to achieve the same.",
        "Continue your race on the same topic till you move ahead of the exam Benchmark.",
        "Monitor this on the progress bar which will turn green on you crossing the benchmark.",
      ],
      url: "selfassessor?gotab=advance",
    });

  } 

  if(mySelectedCourses && selectedCourse && mySelectedCourses[selectedCourse] && mySelectedCourses[selectedCourse].topicTest===1){
    steps.push({
      icon: "/static/images/s5.svg",
      title: "Final Check of Your Knowledge",
      subtitle: "Take the test in exam like simulated environment.",
      points: [
        "ETL Topic tests are AI simulated exam like tests on the topic with similar difficulty, time, and negative marking.",
        "Monitor your last step in report and analytics.",
      ],
      url: "selecttopictest",
    });
  }

  if(mySelectedCourses && selectedCourse && mySelectedCourses[selectedCourse] && mySelectedCourses[selectedCourse].mockTest===1){
    steps.push({
      icon: "/static/images/s6.svg",
      title: "Mock Tests Stops Exam Stress",
      subtitle:
        "Take the Mock Test only a few days before the exam date otherwise, you will lose confidence.",
      points: [
        "ETL Mock tests are available both for subject and complete exams.",
        "Mock tests are AI simulated in exam like environment with high accuracy.",
        "Your progress bar in green indicates you are heading toward success.",
      ],
      url: "selectmocktest",
    });
  }

  steps.push({
    icon: "/static/images/s7.svg",
    title: "PERFORMANCE ANALYTICS",
    subtitle: "Game Changer in optimizing your preparation.",
    points: [
      "ETL Performance Analytics is available from Step 2 to Step 6 to monitor your progress, speed, accuracy, and consistency.",
      "In Mock Tests, have the additional facility to drill down and pinpoint the exact topic where you are struggling. This is of great help when few days are left for exams.",
    ],
  });

  
  return (
    <div className={styles.preparation_flow} id={"preparation-flow"}>
      <h2 className={styles.section_heading}>The Exam Preparation Flow</h2>
      <div className={styles.timeline}>
        {steps.map((step, index) => (
          <div className={styles["timeline-item"]} key={index}>
            <div className={styles["timeline-dot"]} />
            <div className={styles["timeline-content"]}>
              <img src={step.icon} alt={step.title} />  
              <div>
                <h2>{step.title.indexOf("PERFORMANCE ANALYTICS")===-1?<>STEP {index+1}: {step.title}</>:step.title}</h2>
                <h4>{step.subtitle}</h4>
                <ul>
                  {step.points.map((point, idx) => (
                    <li key={idx}>{point}</li>
                  ))}
                </ul>

                {step?.url ? (
                  <a className={styles.letsgo} href={step.url}>
                    LETS GO
                  </a>
                ) : (
                  <></>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

